import { getStyle } from './DatanauswertungGenerischStyles';
import { LineDiagram } from '../helper/lineChart';
import { PieDiagram } from '../helper/pieChart';
import * as React from 'react';
import { StackedBarChartHorizontal } from '../helper/stackedBarChartHorizontal';
import { SimpleBarChart } from '../helper/simpleBarChart';

export function renderDiagram(diagrams: any[], style?: any, id?: string): JSX.Element {
    // console.log(diagrams);
    if (Array.isArray(diagrams) && diagrams.length > 0) {
        const customDiagrammWrapperStyle = style && style.diagrammWrapper ? style.diagrammWrapper : {};

        return <div style={{ ...getStyle('diagrammWrapper'), ...customDiagrammWrapperStyle }}>
            {diagrams.map((d: any, i: number) => {
                let styDigm = getStyle('diagramm');
                let titleRenderer: any = null;
                const elemSelectPosition = (['title', 'chart'].indexOf(d.elemSelectPosition) !== -1 && d.elemSelectPosition) || 'chart'; // 'chart' = default, nur 'title' | 'cart' gültig

                if (i === diagrams.length - 1) {
                    styDigm.marginRight = 0;
                }

                if (d.hideTitle) {
                    styDigm.padding = 15;
                    styDigm.border = '1px solid #eee';
                    delete (styDigm.borderTopLeftRadius);
                    delete (styDigm.borderTopRightRadius);
                } else {
                    titleRenderer = (title: string, elem?: JSX.Element) => {
                        const additionalStyle = elem
                            ? {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                padding: '0px 10px 0px 20px'
                            }
                            : {};
                        const addElem = elem
                            ? <div>{elem}</div>
                            : null;
                        return <div style={{...getStyle('diagrammTitle'), ...additionalStyle}}>
                            <div>{title}</div>{addElem}</div>;
                    }
                }
                styDigm = { ...styDigm, ...(d.diagramStyle || {}) }
                return <div style={styDigm} key={`diagramm_${i}`}>
                    {(!d.type || d.type === 'LineDiagram') &&
                        <LineDiagram
                            data={d.data}
                            X_dataKey={d.X_dataKey}
                            visibleData={d.Y_dataKey}
                            legendTitle={d.legend}
                            unit={d.unit}
                            createNewTick
                            singleYAxis={d.singleYAxis}
                            lineColor={d.lineColor}
                            containerSize={d.containerSize}
                            id={id}
                            bgColor={d.bgColor}
                            legendProps={{ wrapperStyle: { position: 'absolute' } }}
                            lineChartProps={{ margin: { top: 8, right: 0, bottom: 0, left: 0 }, style: { display: 'inherit' } }}
                            customTickFormatter={d.customTickFormatter}
                            setTitle={(elem: JSX.Element) => {
                                return (typeof titleRenderer === 'function' && titleRenderer(d.title, elem)) || null;
                            }}
                        />
                    }
                    {d.type === 'StackedBarChartHorizontal' &&
                        <StackedBarChartHorizontal
                            data={d.data}
                            XKey={d.Y_dataKey}
                            YKey={d.X_dataKey}
                            XTicks={d.XTicks}
                            YTicks={d.YTicks}
                            legend={d.legend}
                            unit={d.unit}
                            color={d.lineColor}
                            containerSize={d.containerSize}
                            id={id}
                            setTitle={(elem: JSX.Element) => {
                                return (typeof titleRenderer === 'function' && titleRenderer(d.title, elem)) || null;
                            }}
                        />
                    }
                    {d.type === 'SimpleBarChart' &&
                        <SimpleBarChart
                            data={d.data}
                            XKey={d.X_dataKey}
                            YKeys={d.Y_dataKey}
                            customLegends={d.customLegends}
                            legendProps={d.legendProps}
                            containerSize={d.containerSize}
                            id={id}
                            selectable={d.chartSelectable}
                            selectedChartKey={d.selectedChartKey}
                            onSelectChange={d.chartSelectChange}
                            setTitle={(elem: JSX.Element) => {
                                return (typeof titleRenderer === 'function' && titleRenderer(d.title, elem)) || null;
                            }}
                            elemSelectPostition={elemSelectPosition}
                        />
                    }

                    {d.type === 'PieChart' && 
                        <PieDiagram
                            layout={d.layout}
                            data={d.data}
                            legendTitle={d.legend}
                            unit={d.unit}
                            fillColor={d.lineColor}
                            containerSize={d.containerSize}
                            id={id}
                            hideLabelsFilter={d.hideLabelsFilter}
                            selectable={d.chartSelectable}
                            selectedChartKey={d.selectedChartKey}
                            onSelectChange={d.chartSelectChange}
                            getChartSelector={d.getChartSelector}
                            customStyle={d.customStyle}
                            customLegendStyle={d.customLegendStyle}
                            setTitle={(elem: JSX.Element) => {
                                return (typeof titleRenderer === 'function' && titleRenderer(d.title, elem)) || null;
                            }}
                            elemSelectPostition={elemSelectPosition}
                        />
                    }
                </div>;
            })}
        </div>;
    }
}
